import { render, staticRenderFns } from "./OrgEdit.vue?vue&type=template&id=6ad37148"
import script from "./OrgEdit.vue?vue&type=script&lang=js"
export * from "./OrgEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/3e17078e833b83b1/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ad37148')) {
      api.createRecord('6ad37148', component.options)
    } else {
      api.reload('6ad37148', component.options)
    }
    module.hot.accept("./OrgEdit.vue?vue&type=template&id=6ad37148", function () {
      api.rerender('6ad37148', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/modules/admin/components/CrossOrg/OrgEdit.vue"
export default component.exports